import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import { SharedState } from '../../state/shared/shared.reducers';
import { Store } from '@ngrx/store';
import { selectEditMode } from '../../state/shared/shared.selectors';
import { ActivatedRoute, Router } from '@angular/router';
import { map, retry } from 'rxjs/operators';
import { TixAuthService } from '@tix/auth/services';
import { Observable } from 'rxjs';
import { User } from '@angular/fire/auth';

@Component({
  selector: 'tix-public-layout',
  templateUrl: './public-layout.component.html',
  styleUrls: ['./public-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'tix-layout'
  }
})
export class TixPublicLayoutComponent implements OnInit {
  isEditMode: boolean;
  showRightSection = true;
  user$: Observable<User | null>;

  constructor(
    private readonly store: Store<SharedState>,
    private route: ActivatedRoute,
    private authService: TixAuthService,
    private router: Router
  ) {
    this.user$ = this.authService.loadUser();
  }

  ngOnInit(): void {
    this.store.select(selectEditMode).subscribe({
      next: mode => (this.isEditMode = mode)
    });

    // Read hideRightSection from route data
    this.route.data
      .pipe(map(data => !data['hideRightSection']))
      .subscribe(show => {
        this.showRightSection = show;
      });
  }

  onLogout(): void {
    this.authService
      .logout()
      .pipe(retry(3))
      .subscribe(() => (window.location.href = '/auth/login'));
  }
}
